module.exports = {"451228100":"安阳镇","451228101":"高岭镇","451228102":"地苏镇","451228103":"下坳镇","451228104":"拉烈镇","451228105":"百旺镇","451228106":"澄江镇","451228107":"大兴镇","451228108":"拉仁镇","451228204":"东庙乡","451228208":"隆福乡","451228209":"保安乡","451228210":"板岭乡","451228211":"永安乡","451228212":"三只羊乡","451228213":"龙湾乡","451228214":"菁盛乡","451228217":"加贵乡","451228219":"九渡乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/451228.json
// module id = 1991
// module chunks = 0